import { createBrowserRouter, RouterProvider } from 'react-router';

import { Toaster } from './components/ui/toaster';
import { AppHomeRoute } from './routes/app-home';
import { GrammarLessonRoute } from './routes/grammar-lesson';
import { GrammarReviewRoute } from './routes/grammar-review';
import { HomeRoute } from './routes/home';
import { LibraryRoute } from './routes/library';
import { MistakesRoute } from './routes/mistakes';
import { PracticeRoute } from './routes/practice';
import { ResultsRoute } from './routes/results';
import { SettingsRoute } from './routes/settings';
import { SimulationRoute } from './routes/simulation';
import { SimulationResultRoute } from './routes/simulation-result';
import { StatsRoute } from './routes/stats';

const router = createBrowserRouter([
  { path: '/', element: <HomeRoute /> },
  { path: '/apps/:appId', element: <AppHomeRoute /> },
  { path: '/apps/:appId/practice', element: <PracticeRoute /> },
  { path: '/apps/:appId/lessons/:n', element: <GrammarLessonRoute /> },
  { path: '/apps/:appId/review', element: <GrammarReviewRoute /> },
  { path: '/apps/:appId/results', element: <ResultsRoute /> },
  { path: '/apps/:appId/simulation', element: <SimulationRoute /> },
  { path: '/apps/:appId/simulation/result', element: <SimulationResultRoute /> },
  { path: '/apps/:appId/questions', element: <LibraryRoute /> },
  { path: '/apps/:appId/stats', element: <StatsRoute /> },
  { path: '/apps/:appId/mistakes', element: <MistakesRoute /> },
  { path: '/settings', element: <SettingsRoute /> },
]);

export function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  );
}
